import {
	SERVER_GET_REPORTS,
	SET_REPORTS,
	SERVER_GET_REPORT_DETAILS,
	SET_REPORT_DETAILS,
	UPDATE_REPORT_STATUS,
	ASSIGN_REPORT_TO_USER,
	SERVER_COMPLETE_REPORT,
	SERVER_DELETE_REPORT,
	SERVER_RESTORE_REPORT,
	SERVER_REMOVE_REPORT_IN_PROCESS,
	SERVER_SET_REPORT_IN_PROCESS,
	SERVER_ASSIGN_USER_TO_REPORT,
	SERVER_ADD_USER_COMMENT,
	ADD_USER_COMMENT
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	reportList: [],
	reportDetails: {},
	loading: {
		reportList: false,
		reportDetails: false,
		completeReport: false,
		deleteReport: false,
		restoreReport: false,
		setInProcess: false,
		removeInProcess: false,
		assignUser: false,
		addUserComment: false
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		// Loadingflag für das Laden der Meldungsliste
		case SERVER_GET_REPORTS:
			return { ...state, loading: { ...state.loading, reportList: true } };
		// Meldungsliste im Redux State speichern
		case SET_REPORTS:
			return {
				...state,
				reportList: action.payload.reportList,
				loading: { ...state.loading, reportList: false }
			};
		// Loadingflag für das Laden von Meldungsdetails
		case SERVER_GET_REPORT_DETAILS:
			return { ...state, reportDetails: {}, loading: { ...INITIAL_STATE.loading, reportDetails: true } };
		// Meldungsdetails im Redux State speichern
		case SET_REPORT_DETAILS:
			return {
				...state,
				reportDetails: action.payload.reportDetails,
				loading: { ...state.loading, reportDetails: false }
			};
		// Loadingflag Meldung als erledigt markieren
		case SERVER_COMPLETE_REPORT:
			return { ...state, loading: { ...state.loading, completeReport: true } };
		// Loadingflag Meldung als gelöscht markieren
		case SERVER_DELETE_REPORT:
			return { ...state, loading: { ...state.loading, deleteReport: true } };
		// Loadingflag Meldung wiederherstellen
		case SERVER_RESTORE_REPORT:
			return { ...state, loading: { ...state.loading, restoreReport: true } };
		// Loadingflag Meldungstatus auf "In Bearbeitung" setzen
		case SERVER_SET_REPORT_IN_PROCESS:
			return { ...state, loading: { ...state.loading, setInProcess: true } };
		// Loadingflag Meldungsstatus "In Bearbeitung" zurücksetzen
		case SERVER_REMOVE_REPORT_IN_PROCESS:
			return { ...state, loading: { ...state.loading, removeInProcess: true } };
		// Loadingflag Nutzer einer Meldung zuweisen
		case SERVER_ASSIGN_USER_TO_REPORT:
			return { ...state, loading: { ...state.loading, assignUser: true } };
		// Status einer Meldung im Redux State aktualisieren
		case UPDATE_REPORT_STATUS:
			return {
				...state,
				reportList: state.reportList.map(report =>
					report.reportId === action.payload.reportId
						? {
								...report,
								status: action.payload.status,
								...action.payload.dataUpdate
						  }
						: report
				),
				reportDetails:
					state.reportDetails.reportId === action.payload.reportId
						? { ...state.reportDetails, status: action.payload.status }
						: state.reportDetails,
				loading:
					state.reportDetails.reportId === action.payload.reportId
						? {
								...state.loading,
								completeReport: false,
								deleteReport: false,
								restoreReport: false,
								setInProcess: false,
								removeInProcess: false
						  }
						: state.loading
			};
		// Loadingflag Nutzer einer Meldung zuweisen zurücksetzen
		case ASSIGN_REPORT_TO_USER:
			return {
				...state,
				loading: {
					...state.loading,
					assignUser: false
				}
			};
		// Loadingflag Neuen Kommentar zu einer Meldung eintragen
		case SERVER_ADD_USER_COMMENT:
			return { ...state, loading: { ...state.loading, addUserComment: true } };
		// Neuen Kommentar zur ausgewählten Meldung in Redux State eintragen
		case ADD_USER_COMMENT:
			return {
				...state,
				reportDetails: {
					...state.reportDetails,
					userComments: [action.payload.comment, ...state.reportDetails.userComments]
				},
				loading: { ...state.loading, addUserComment: false }
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/Reports.js